












































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { VueComponent } from "../../shared/types/VueComponent";

@Component({
})
export default class HelpMessage extends Vue {
  @Prop({ type: [ String, Function ] }) readonly helpMessage!: VueComponent | string

  @Prop() customClasses!:Array<string> | string

  @Prop({ type: String, required: false, default: '' }) readonly translationKey!: string

  @Prop() title!: string | undefined

  isHelpPopupOpen = false
}
